<div class="chart" *ngIf="isEcoPro; else normalProject">
  <div class="select-field">
    <mat-label>{{ 'graph_select_indicator' | translate }}</mat-label>
    <div class="mt-4">
      <span *ngFor="let indicator of indicators" class="ms-2 me-2 align-checkbox-text">
        <mat-checkbox [checked]="indicator.isChecked" (change)="onChangeIndicatorSelect($event, indicator)"> {{ indicator.displayName | localizedLabel: 'indicator' : indicator.code }} ({{ indicator.workUnityDisplayShortName }}) </mat-checkbox>
      </span>
    </div>
  </div>
  <mat-form-field class="select-field" appearance="fill">
    <mat-label>{{ 'graph_select_solution' | translate }}</mat-label>
    <mat-select class="select" (selectionChange)="selectSolutionChange($event.value)">
      <mat-option *ngFor="let s of projectData.solutionsEcoPro" [value]="s.solutionEcoProId">
        {{ s?.displayName }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <highcharts-chart appAutoReflow class="chart-graph" *ngIf="indicatorComparatif.indicatorId && solutionComparatif.solutionEcoProId" [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag" [oneToOne]="true"> </highcharts-chart>
</div>

<ng-template #normalProject>
  <div class="chart">
    <div class="select-field">
      <mat-label>{{ 'graph_select_indicator' | translate }}</mat-label>
      <div class="mt-4">
        <span *ngFor="let indicator of indicators" class="ms-2 me-2 align-checkbox-text">
          <mat-checkbox [checked]="indicator.isChecked" (change)="onChangeIndicatorSelect($event, indicator)"> {{ indicator.displayName | localizedLabel: 'indicator' : indicator.code }} ({{ indicator.workUnityDisplayShortName }}) </mat-checkbox>
        </span>
      </div>
    </div>
    <mat-form-field class="select-field" appearance="fill">
      <mat-label>{{ 'graph_select_solution' | translate }}</mat-label>
      <mat-select class="select" (selectionChange)="changeSolution($event.value)" [(value)]="selectedSolution">
        <mat-option *ngFor="let s of this.solutions" [value]="s.solutionId">
          {{ s.displayName }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <highcharts-chart appAutoReflow class="chart-graph" *ngIf="indicatorComparatif.indicatorId && solutionComparatifProjet.solutionId" [Highcharts]="Highcharts" [options]="chartOptions" [(update)]="updateFlag" [oneToOne]="true"> </highcharts-chart>
  </div>
</ng-template>
